import { Heading2 } from 'components/shared/Typography';
import styled from 'styled-components';
import { container, fontSize, screen, spacing } from '../../../theme';

export const StyledSection = styled.div`
  padding: ${spacing('xl6')} ${spacing('md')} ${spacing('xl3')};
  max-width: ${container('md')};
  margin: auto;

  ${Heading2} {
    text-align: center;
    margin-bottom: ${spacing('md')};
  }
`;

export const StyledContent = styled.div`
  font-size: ${fontSize('md')};
  line-height: 1.6;
  margin-left: auto;
  margin-right: auto;
  text-align: left;

  @media (min-width: ${screen('lg')}) {
    font-size: ${fontSize('lg')};
  }
`;
